import { createAction } from '@mews/framework';
import { ApplicationState, ResourceCategoryAvailability } from '@mews-commander/types';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'availabilities';

const AVAILABILITIES_LOADED = prefix('AVAILABILITIES_LOADED');

export const setAvailabilities = (entities: ResourceCategoryAvailability[]) =>
    createAction(AVAILABILITIES_LOADED, { entities });

export const availabilitiesReducer = createEntitiesReducer({ FETCH_SUCCESS: AVAILABILITIES_LOADED });

export const [getAvailabilities] = createBaseEntitySelectors<
    ApplicationState,
    ResourceCategoryAvailability[],
    typeof NAME
>(moduleSelector, NAME);
